import React, { useState, useEffect, useContext } from 'react';
import { Link, useNavigate, useParams } from "react-router-dom";
import { InputContext } from '../contexts/InputContext';
import TextControl from '../components/customizedInputs/TextControl';
import usuariosServices from '../services/usuariosServices';
import { errorMessage } from '../errorHandler';
import BotonVolver from '../components/BotonVolver';

const RecuperoClave = () => {
  const navigate = useNavigate();
  const [authInformation, setAuthInformation] = useContext(InputContext)
  const [recupero, setRecupero] = useState({
    token: "",
    password: "",
    password_confirmation: ""
  });
  const [usuario, setUsuario] = useState('');
  const [renderHTML, setRenderHTML] = useState(false);
  const [esCambioDeClave, setEsCambioDeClave] = useState(false);

  let { token } = useParams();

  useEffect(() => {
    if(token){
      setEsCambioDeClave(true)
      setRecupero({...recupero,
        token: token
      })
    } else {
      setEsCambioDeClave(false)
    }
  }, []);

  useEffect(() => {
    if(authInformation.autenticado === true){
      navigate(`/`);
    } else {
      setRenderHTML(true)
    }

  }, [authInformation]);


  const olvidoClave = async () => {
    try {
      const data = await usuariosServices.olvidoClave(usuario);

      alert(data.message)
    } catch (error) {
      errorMessage(error)
    }
  };

  const recuperoClave = async () => {
    try {
      const data = await usuariosServices.recuperoClave(recupero);

      alert(data.message)
      navigate(`/ingreso`);
    } catch (error) {
      errorMessage(error)
    }
  };

  const handleInput = (e) => {
    const { name, value } = e.target;
    setRecupero({...recupero,
      [name]: value
    })
  }

  const handleInputUsuario = (e) => {
    const { name, value } = e.target;
    setUsuario(value)
  }

  const handleFormSubmit = (e) => {
    e.preventDefault()
    if(token){
      recuperoClave()
    } else {
      olvidoClave()
    }
  }

  return (
    <>
      {
        renderHTML && (
          <main className="w-100 m-auto" style={{maxWidth: '660px'}}>
            <form>
              <div className="card mb-3">
                <div className="card-body">
                  {
                    esCambioDeClave ? (
                      <>
                        <h5 className="card-title">Cambie su clave</h5>
                        <div className='row mb-3'>
                          <div className='col-sm-6'>
                            <TextControl
                              value={recupero.password}
                              name={'password'}
                              handleInput={handleInput}
                              type='password'
                              label='Nueva clave'
                              />
                          </div>
                          <div className='col-sm-6'>
                            <TextControl
                              value={recupero.password_confirmation}
                              name={'password_confirmation'}
                              handleInput={handleInput}
                              type='password'
                              label='Repita la nueva clave'
                              />
                          </div>
                        </div>
                      </>
                    ) : (
                      <>
                        <h5 className="card-title">Olvidaste la clave ?</h5>
                        <TextControl
                          value={usuario || ''}
                          name={'usuario'}
                          handleInput={handleInputUsuario}
                          label='Ingrese su usuario para recuperar la clave'
                          />
                      </>
                    )
                  }

                </div>
              </div>

              <div className="d-grid gap-2 d-sm-flex justify-content-sm-center">
                <button className="btn btn-primary w-100 py-2" onClick={handleFormSubmit} type="submit">Cambiar clave</button>
                <BotonVolver />
              </div>

            </form>
          </main>
        )
      }

    </>
  );
};

export default RecuperoClave;